import { ReadOnlyArray } from '../../array/ReadOnlyArray';
import type { CatalogConfigProps } from './DefaultCatalogConfig';
import DefaultCatalogConfig, { IMAGE_DISABLED } from './DefaultCatalogConfig';

export default class AutomatedCatalogConfig extends DefaultCatalogConfig {
  constructor(props: CatalogConfigProps) {
    super(props);
    this.allowedSources = ReadOnlyArray.Empty;
    this.editable = false;
    this.indentTree = false;
    this.allowHoverActions = props.isGlobalEditor;
    this.allowRanking = props.isGlobalEditor;

    this.category = {
      ...this.category,
      levelRestriction: false,
      levelEditable: [0],
      hide: false,
      rename: false,
      translation: props.isEditorForCurrentMarket,
      comment: true,
      delete: false,
      publish: false,
      autoCategorisable: false,
      import: false,
      categoryType: false,
      image: IMAGE_DISABLED,
      productImage: IMAGE_DISABLED,
      redirectIdRequired: false,
    };
  }
}
